import { MutationOptions, useMutation } from '@tanstack/react-query'
import { buildRelationshipForUpdate } from '@opallabs/json-api'
import { createBlockConnector } from './requests/create'
import {
  BlockConnectorResponseDocument,
  CreateBlockConnectorRequestBody,
} from './types'

export type CreateBlockConnectorParams = {
  blockId: string
  view: { id: string; name: string | null }
  category?: { id: string; name: string | null }
}

type OnMutateHandler = (params: CreateBlockConnectorParams) => void
type OnSuccessHandler = (
  data: BlockConnectorResponseDocument,
  params: CreateBlockConnectorParams
) => void

function buildRequestBody({
  blockId,
  view,
  category,
}: CreateBlockConnectorParams): CreateBlockConnectorRequestBody {
  return {
    data: {
      type: 'block_connector',
      attributes: {},
      relationships: {
        block: { data: { id: blockId, type: 'block' } },
        view: { data: { id: view.id, type: 'view' } },
        ...buildRelationshipForUpdate({
          relationshipKey: 'category',
          resourceType: 'category',
          idOrIds: category?.id,
        }),
      },
    },
  }
}

type QueryParams = {
  mutationKey?: MutationOptions['mutationKey']
  onMutate?: OnMutateHandler
  onSuccess?: OnSuccessHandler
}

export function useCreateBlockConnector({
  mutationKey,
  onMutate,
  onSuccess,
}: QueryParams) {
  return useMutation({
    mutationKey,
    mutationFn: (params: CreateBlockConnectorParams) =>
      createBlockConnector({
        requestBody: buildRequestBody(params),
      }),
    onMutate: onMutate,
    onSuccess: onSuccess,
  })
}
